<div class="text-left">
    <div class="selectWeekend" style="padding-top: 10px;"><b>Weekend Dates</b></div>
    <div class="relative">
        <ng-select #weekendSelect [items]="newlyAdded" bindLabel="text" bindValue="" [multiple]="true"
            [closeOnSelect]="false" [loading]="weekendLoading" [typeahead]="weekendInput$"
            typeToSearchText="Weekend Name" [virtualScroll]="true" [(ngModel)]="selectedWeekend"></ng-select>
        <i class="fa fa-search"></i>
    </div>
</div>